import { createApp } from "vue";
import shojo from "./shojo.vue";
createApp(shojo).mount("#app");
